import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Home from "./pages/Home";
import AppLayout from "./Layout/AppLayout";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import WhatsAppFloating from "./components/WhatsApp";
import AboutPage from "./pages/About";
import ContactPage from "./pages/Contact";
import AdminPage from "./pages/Admin";

// Layout wrapper for public pages
function PublicLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Pages with Header/Footer Layout */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/contact-us" element={<ContactPage />} />
        </Route>

        {/* Admin Page without Header/Footer Layout */}
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <WhatsAppFloating />
    </BrowserRouter>
  );
}
